import { render, staticRenderFns } from "./modal-ecom-details.vue?vue&type=template&id=ddf98fc8&scoped=true"
import script from "./modal-ecom-details.vue?vue&type=script&lang=js"
export * from "./modal-ecom-details.vue?vue&type=script&lang=js"
import style0 from "./modal-ecom-details.vue?vue&type=style&index=0&id=ddf98fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf98fc8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAlert: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_073241/resources/assets/marketplace/components/BaseAlert.vue').default})
